const SafariTools = (() => {

  const isWebpSupported = async () => {
    if (!self.createImageBitmap) return false;

    const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
    const blob = await fetch(webpData).then(r => r.blob());
    return createImageBitmap(blob).then(() => true, () => false);
  };

  const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const getBackgroundUrl = bg => bg.replace(/url\(['"]?(.*?)['"]?\)/i, "$1");
  const getSrc = img => img.getAttribute('data-src') || img.getAttribute('src') || '';

  const getBackgroundImage = element => {
    if (element.currentStyle) return getBackgroundUrl(el.currentStyle.backgroundImage);

    const isFirefox = document.defaultView && document.defaultView.getComputedStyle;
    if (isFirefox) return getBackgroundUrl(document.defaultView.getComputedStyle(element, '').backgroundimage);

    return getBackgroundUrl(element.style.backgroundImage);
  };

  const getPNGData = async () => {
    const url = '/pages/json-api';
    const response = await fetch(url);
    if (!response) return;
    const data = await response.json();
    if (!data) return;

    const {pngs} = data;
    return pngs;
  };

  const getBaseFilename = filename => {
    return filename
    .split('/')
    .slice(-1)[0]
    .split('?')[0];
  };

  const getWebpImages = () => {
    const imgs = [...document.querySelectorAll('img')];
    const webpImages = imgs.filter(img => getSrc(img).includes('.webp'));
    return webpImages;
  };

  const patchImages = pngData => {
    const webpImages = getWebpImages();
    for (const image of webpImages) {
      const src = getSrc(image);
      const filename = getBaseFilename(src);
      const pngFilename = pngData[filename];

      image.setAttribute('data-src', pngFilename);
      image.setAttribute('src', pngFilename);
    }
  }

  const patchBanners = pngData => {
    const banners = [...document.querySelectorAll('.banner-slide')];
    for (const banner of banners) {
      if (banner.style.backgroundImage.includes('.png')) continue;

      const webpUrl = getBaseFilename(
        banner.style.backgroundImage
        .replace('url("', '')
        .replace('")', '')
      );

      const pngFilename = pngData[webpUrl];
      banner.style.backgroundImage = `url(${pngFilename})`;
    }
  };

  const patchBackground = pngData => {
    const burlaps = [...document.querySelectorAll('.burlap-bg, .header')];
    const pngFile = pngData['burlap-bg.webp'];
    for (const burlap of burlaps) {
      burlap.style.backgroundImage = `url(${pngFile})`;
    }
  };

  const patchFeaturedCollections = pngData => {
    const jsonContainer = document.querySelector('#featured-collections-links');
    if (!jsonContainer) return;
    const rawJson = jsonContainer.textContent;
    const fcData = JSON.parse(rawJson);
    const isMobile = window.innerWidth < 1000;
    const plData = fcData[isMobile ? 'mobile' : 'desktop'];
    const collectionGridItems = [...document.querySelectorAll('.collection-grid-item__overlay')];
    for (const item of collectionGridItems) {
      const fcClass = [...item.classList].find(cl => cl.indexOf('fc-') === 0);
      const pngFile = plData['.' + fcClass];
      item.style.backgroundImage = `url(${pngFile})`;
    }
  };

  const patchAllImages = pngData => {
    patchImages(pngData);
    patchBanners(pngData);
    patchBackground(pngData);
    patchFeaturedCollections(pngData);
  };

  const setLimitedInterval = (handler, intervalTime, limit) => {
    let counter = 0;
    const inter = setInterval(() => {
      handler();
      if (++counter >= limit) clearInterval(inter);
    }, intervalTime);
  }

  const init = async () => {
    if (isWebpSupported() || isSafari()) return;

    const pngData = await getPNGData();
    const patcher = () => patchAllImages(pngData);

    document.addEventListener('scroll', patcher);
    document.addEventListener('load', patcher);
    document.addEventListener('visibilitychange', patcher);
    document.addEventListener('click', patcher);

    setLimitedInterval(patcher, 100, 5);
    setInterval(patcher, 5000);
  };
  init();

  return {isWebpSupported, getBackgroundImage, getPNGData};
})();